import { useMemo } from 'react';

import { useAppStateContext } from '~components/providers/AppStateProvider';
import { sm } from '~components/theme/breakpoints';

export function useIsMobile(breakWidth: number = sm) {
  const { width, isClient } = useAppStateContext();

  const isMobile = useMemo(() => width < breakWidth && isClient, [width, breakWidth, isClient]);

  return isMobile;
}
